import React, { PropTypes } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import {API} from '../../settings.js';
import {ajaxPost} from '../../helpers/apiData.js';

import FeedbackRadios from '../FeedbackRadios';

class RestaurantFeedback extends React.Component {
  static propTypes = {
    match: PropTypes.object,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.current_stage = 0;

    this.state = {
      back: "",
      choice: null,
      presentation: null,
      tasty: null,
      speed: null,
      waiters: null,
      overall: null,
      deco: null,
      price: null,
      recommend: null,
      error: true,
      comments: '',
      sent: '',
      stage: 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.moveNext = this.moveNext.bind(this);
    this.movePrev = this.movePrev.bind(this);
  }

  componentDidMount() {
    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    this.props.view_info(
      //title
      (
        <FormattedMessage id="nav-feedback">
          {(message) => <span>{message}</span>}
        </FormattedMessage>
      ),
      //view
      'feedback',
      //back button or not
      false
    );
  }

  shouldComponentUpdate() {
    return this.state.stage !== 0;
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if(name === 'comments') {
      this.setState({
        [name]: value
      });
    }
    else {
      this.setState({
        [name]: Number(value)
      });
    }
  }

  handleSubmit(event) {
    ajaxPost(API +  this.props.match.params.lang + '/api/restaurant/' + this.props.match.params.restaurant +'/feedback/',
      {'choice': this.state.choice, 'presentation': this.state.presentation, 'tasty': this.state.tasty,
        'speed': this.state.speed, 'waiters': this.state.waiters, 'overall': this.state.overall,
        'deco': this.state.deco, 'price': this.state.price, 'recommend': this.state.recommend,
        'comments': this.state.comments}, this);

      this.setState({sent: 'sent'});
      event.preventDefault();
  }

  moveNext() {
    this.current_stage = this.state.stage;
    this.current_stage++;

    this.setState({stage: this.current_stage});
    document.getElementById("tieredForm").className += " stage-" + this.current_stage;
  }

  movePrev() {
    this.current_stage = this.state.stage;

    if(this.current_stage > 0) {
      document.getElementById("tieredForm").classList.remove("stage-" + this.current_stage);
      this.current_stage--;
      this.setState({stage: this.current_stage});

    }
  }

  render() {
    return (
      <div className="feedback-wrapper">
        <div className={"feedback-form-wrapper " + this.state.sent}>
          <form className="restaurant-feedback feedback-form" onSubmit={this.handleSubmit}>
           <div id="tieredForm">

             {/* STEP 1 */}
             <fieldset className="form-step stage-0">
              <img src={require('../../images/placeholder_prato.jpg')} />
              <FormattedMessage id="restaurant-feedback-title">
                {(message) => <h2 className="feedback-title">{message}</h2>}
              </FormattedMessage>
              <FormattedMessage id="restaurant-feedback-intro">
                {(message) => <p className="intro-text">{message}</p>}
              </FormattedMessage>
               <footer>
                 <FormattedMessage id="restaurant-feedback-intro-btn">
                   {(message) => <a href="#" className="btn feedback-btn" onClick={this.moveNext}>{message}</a>}
                 </FormattedMessage>
               </footer>
            </fieldset>

             {/* STEP 2 */}
             <fieldset className="form-step">
               <FormattedMessage id="food-feedback-title">
                 {(message) => <h2 className="feedback-title">{message}</h2>}
               </FormattedMessage>
               <FormattedMessage id="food-feedback-intro">
                 {(message) => <p className="intro-text">{message}</p>}
               </FormattedMessage>
               <FormattedMessage id="choice-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'choice'}/>

               <FormattedMessage id="presentation-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'presentation'}/>

               <FormattedMessage id="tasty-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'tasty'}/>

               <footer>
                 <div className={'stage-meter stage-' + this.state.stage}>{this.state.stage}/3</div>
                 <a href="#" type="button" className="slick-arrow slick-prev" onClick={this.movePrev}/>
                 <a href="#" type="button" className="slick-arrow slick-next" onClick={this.moveNext}/>
               </footer>

             </fieldset>

             {/* STEP 3 */}
             <fieldset className="form-step">
               <FormattedMessage id="service-feedback-title">
                 {(message) => <h2 className="feedback-title">{message}</h2>}
               </FormattedMessage>
               <FormattedMessage id="food-feedback-intro">
                 {(message) => <p className="intro-text">{message}</p>}
               </FormattedMessage>
               <FormattedMessage id="speed-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'speed'}/>

               <FormattedMessage id="waiters-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'waiters'}/>

               <FormattedMessage id="overall-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'overall'}/>

               <footer>
                 <div className={'stage-meter stage-' + this.state.stage}>{this.state.stage}/3</div>
                 <a href="#" type="button" className="slick-arrow slick-prev" onClick={this.movePrev}/>
                 <a href="#" type="button" className="slick-arrow slick-next" onClick={this.moveNext}/>
               </footer>
             </fieldset>

             {/* STEP 4 */}
             <fieldset className="form-step">
               <FormattedMessage id="global-feedback-title">
                 {(message) => <h2 className="feedback-title">{message}</h2>}
               </FormattedMessage>
               <FormattedMessage id="food-feedback-intro">
                 {(message) => <p className="intro-text">{message}</p>}
               </FormattedMessage>
               <FormattedMessage id="deco-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'deco'}/>

               <FormattedMessage id="price-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'price'}/>

               <FormattedMessage id="recommend-question">
                 {(message) => <p className="question-text">{message}</p>}
               </FormattedMessage>
               <FeedbackRadios name={'recommend'}/>

               <div className="comments-area">
                 <FormattedMessage id="comments-question">
                   {(message) => <label htmlFor="comments">{message}</label>}
                 </FormattedMessage>
                 <textarea name="comments" id="comments" value={this.state.comments} onChange={this.handleChange}/>
               </div>
               <footer>
                 <div className={'stage-meter stage-' + this.state.stage}>{this.state.stage}/3</div>
                 <button type="button" className="slick-arrow slick-prev" onClick={this.movePrev}/>
                 <FormattedMessage id="feedback-submit">
                   {(message) => <input className="btn" type="submit" value={message}/>}
                 </FormattedMessage>
               </footer>
             </fieldset>
            </div>
          </form>
        </div>

        <div className={'thanks ' + this.state.sent}>
          <img src={require('../../images/placeholder_prato.jpg')} />
          <FormattedMessage id="feedback-thanks-title">
            {(message) => <h3>{message}</h3>}
          </FormattedMessage>
          <FormattedMessage id="feedback-thanks-text">
            {(message) => <p>{message}</p>}
          </FormattedMessage>
          <Link className="thanks-btn btn"
                to={'/' + this.props.match.params.lang + '/' + this.props.match.params.restaurant + '/'}>
            <FormattedMessage id="nav_home">
              {(message) => <span>{message}</span>}
            </FormattedMessage>
          </Link>
        </div>
      </div>
    );
  }
}

export default RestaurantFeedback;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/RestaurantFeedback.js
 **/